import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

interface CollapsibleSectionProps {
    title: string;
    icon: React.ComponentType<any>;
    children: React.ReactNode;
    defaultOpen?: boolean;
    action?: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
    title,
    icon: Icon,
    children,
    defaultOpen = true,
    action
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <section className="collapsible-section-wrapper">
            <div className="collapsible-section-header" onClick={() => setIsOpen(!isOpen)}>
                <div className="collapsible-section-title-group">
                    <Icon size={16} />
                    <h3>{title}</h3>
                </div>
                <div className="flex items-center gap-4" onClick={(e) => e.stopPropagation()}>
                    {action}
                    <ChevronDown
                        size={16}
                        className={`collapsible-section-chevron ${isOpen ? 'open' : 'closed'}`}
                    />
                </div>
            </div>
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        initial={{ height: 0, opacity: 0, overflow: 'hidden' }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                    >
                        <div className="collapsible-section-content pt-2">
                            {children}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
};

export default CollapsibleSection;
